import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RailMyBoxRoles } from '../util';
import { AuthQuery } from '../store/auth';
import { map } from 'rxjs';

export const routeGuard: CanActivateFn = (route, _state) => {
  const router = inject(Router);
  const authQuery = inject(AuthQuery);
  const allowedRoles = (route.data['roles'] as string[]) ?? [];
  const userRoles = authQuery.getUserRoles();
  const isAdmin = userRoles.includes(RailMyBoxRoles.ADMIN);

  if (isAdmin) {
    return true;
  }

  return authQuery.hasAtLeastOnePermission(allowedRoles).pipe(map((isAllowed) => (isAllowed ? true : router.parseUrl('/access-denied'))));
};
